<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="3" md="6">
				<v-subheader>Permisos</v-subheader>
				<v-list>
					<v-list-item-group v-model="selected" multiple>
						<v-list-item
							dense
							:value="Number(value)"
							:key="key"
							v-for="[key, value] in Object.entries($store.getters.getPermisos).sort(([, v1], [, v2]) => v1 > v2 ? 1 : -1)"
						>
							<template v-slot:default="{ active }">
								<v-list-item-action>
									<v-checkbox :input-value="active"></v-checkbox>
								</v-list-item-action>

								<v-list-item-content>
									<v-list-item-title>{{ key }}</v-list-item-title>
									<v-list-item-subtitle>{{ value }}</v-list-item-subtitle>
								</v-list-item-content>

								<v-icon v-if="$root.acceso(key)">mdi-account</v-icon>
							</template>
						</v-list-item>
					</v-list-item-group>
				</v-list>
				<v-divider></v-divider>
				{{ total }}
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	data() {
		return {
			selected: [],
		}
	},
	computed: {
		total() {
			return this.selected.reduce((t, a) => t + a, 0)
		}
	}
}
</script>

<style>
</style>